<div class="col-lg-12 col-md-12 col-xs-12 padding0px" wheel>
  <div class="col-lg-12 col-md-12 col-sm-12 padding0px" *ngIf="__bHideInboxPageForUserActionThroughURL">
    <div class="col-lg-12 col-md-12 col-sm-12 padding0px">
      <span class="span-user-action-execute-result">{{__sUserActionExecuteResult}}</span>
    </div>
  </div>

  <div class="col-lg-12 col-md-12 col-sm-12 padding0px" *ngIf="!__bHideInboxPageForUserActionThroughURL" [ngClass]="{'hidden':__bHideStateSidebar}">
    <div class="col-lg-12 col-md-12 col-sm-12 padding0px" style="padding: 0.7rem 0; ">
      <dx-button id="WD_Refresh_Btn" text="Refresh Workflow" hint="Refresh Workflow" (onClick)="RefreshWorkflow($event)"  [disabled]="__iBusinessProcessAccordionSelectedIndex < 0"></dx-button>
    </div>
  </div>
  <div id="divInbox" *ngIf="!__bHideInboxPageForUserActionThroughURL" class="row margin0px">

    <div id="accordionPane" class="col-lg-2 col-md-2 col-sm-2 show" [ngClass]="{'hidden':__bHideStateSidebar}">
      <div class="row margin0px div-business-process">
        <div class="row margin0px sidebar-header-section">
          <p><span style="float: left;">Workflows</span></p>
        </div>
        <div id="dvSearchBox" class="col-lg-12 col-md-12 col-xs-12 padding0px">
          <dx-autocomplete #WorkFlowInstanseSearch id="WorkFlowInstanseSearch" placeholder="Search Workflow here..."
                           [dataSource]="__WorkFlowInstanseSearchDataSource"
                           [remoteOperations]="true"
                           [showClearButton]="false"
                           [searchTimeout]="500"
                           [(value)]="__WorkFlowInstanseSearchValue"
                           [maxItemCount]="30"
                           (onSelectionChanged)="onSelectionChanged($event)"
                           (onEnterKey)="GOButtonClicked()"
                           (onItemClick)="GOButtonClicked()">
            <dxi-button name="search" location="after" [options]="searchButton"></dxi-button>
          </dx-autocomplete>
        </div>

        <div id="accordion" class="col-lg-12 col-md-12 col-xs-12 padding0px">
          <dx-accordion class="cl-accordion"
                        #Inboxaccordion
                        [dataSource]="__oBusinessProcessViewModels"
                        [collapsible]="true"
                        [multiple]="false"
                        [animationDuration]="100"
                        [(selectedIndex)]="__iBusinessProcessAccordionSelectedIndex"
                        (onSelectionChanged)="GetBusinessProcessCount($event)">
            <div *dxTemplate="let BusinessProcessViewModel of 'title'">
              <b>{{BusinessProcessViewModel.WorkFlowType.wfBusinessProcessType1}}</b>
            </div>
            <hr />
            <div *dxTemplate="let BusinessProcessViewModel of 'item'">
              <div *ngFor="let item of BusinessProcessViewModel.BusinessProcesses; let i = index" style="margin:2px;">
                <dx-button class="cl-button" *ngIf="item.ItemCount >= 0" [ngClass]="{'btn-active' : __activeProcess == i }"
                           [text]="item.BusinessProcess + ' (' + item.ItemCount + ')'" [hint]="item.BusinessProcess + ' (' + item.ItemCount + ')'"
                           (onClick)="OnBusinessProcessButtonClicked(item.BusinessProcess, i)" style="width:100%; padding:0px !important"></dx-button>

                <dx-button class="cl-button" *ngIf="item.ItemCount < 0" [ngClass]="{'btn-active' : __activeProcess == i }"
                           [text]="item.BusinessProcess" [hint]="item.BusinessProcess"
                           (onClick)="OnBusinessProcessButtonClicked(item.BusinessProcess, i)" style="width:100%; padding:0px !important"></dx-button>

              </div>
            </div>
          </dx-accordion>
        </div>

      </div>


    </div>

    <div class="col-1 div-collapse" [ngClass]="{'hidden':__bHideStateSidebar}">
      <!--*ngIf="__bStateWorkflowVisible || __bStatelessWorkflowVisible"-->
      <p class="pCollapsable" id="collapsablePane">
        <a class="clickable" data-bs-toggle="collapse" data-bs-target="#accordionPane" role="button" (click)="changeIcon()">
          <span class="bluetab_1"></span>
        </a>
      </p>
    </div>

    <div id="divStateWF" *ngIf="__bStateWorkflowVisible" class=" col content">
      <div class="row margin0px height-100">
        <div id="statesPane" class="col-lg-2 col-md-2 col-sm-2 padding0px show" *ngIf="__bStateRightPanelVisisble">
          <div class="row margin0px collapse-pane">
            <div class=" padding0px div-states">
              <div class="row margin0px sidebar-header-section">
                <p>
                  <span title="{{__oBusinessProcessDefinitionName}}" style="float: left;">{{__oBusinessProcessDefinitionName}}</span>
                </p>
              </div>
              <div id="div-states-sidebar-content" class="col-lg-12 col-md-12 col-sm-12 padding0px">
                <div class="col-lg-12 col-md-12 col-sm-12 padding0px" *ngFor="let item of __oBusinessProcessStates; let i = index" style="margin: 0.4rem 0 0 0; ">
                  <dx-button class="cl-button" [ngClass]="{'btn-active' : __activeState == i }" style="width:100%; padding:0px !important"
                             [text]="item.StateWithNoofQueues" [hint]="item.StateWithNoofQueues"
                             (onClick)="OnBusinessProcessStateButtonClicked(item.wfBusinessProcessState, i)"></dx-button>
                </div>
              </div>

            </div>
            <div id="div-state-start-button" class="div-border">
              <dx-button class="cl-button" style="width:90%;height:30px;" [text]="__sStartNewProcessButtonText" [hint]="__sStartNewProcessButtonText"
                         (onClick)="OnNewProcessButtonClicked($event)" [visible]="__bStartNewProcessButtonVisible"></dx-button>
            </div>

          </div>

        </div>
        <div class="col-1 div-collapse" *ngIf="__bStateRightPanelVisisble">
          <p class="pStateCollapsable">
            <a class="clickable" data-bs-toggle="collapse" data-bs-target="#statesPane" role="button" (click)="changeStateCollapseIcon()">
              <span class="bluetab_1" style="margin-top:2px;"></span>
            </a>
          </p>
        </div>

        <div id="div-state-content" class="col content" style="padding: 0px 2px 0px 15px" *ngIf="__bStateRightPanelVisisble">
          <div class="col-lg-12 col-md-12 col-sm-12 iconDiv div-ellipsis" style="height:25px; text-align:center;">
            <span title="{{GetStateWorkflowTitle()}}">{{GetStateWorkflowTitle()}}</span>
          </div>

          <div id="div-StateInstances-grid" class="col-lg-12 col-md-12 col-sm-12 padding0px">
            <dx-data-grid class="dashboard-grid" id="GridStateInstances"
                          [dataSource]="__oStateDataSource"
                          [(columns)]="__oStatecolumns"
                          [allowColumnReordering]="true"
                          [allowColumnResizing]="true"
                          [columnResizingMode]="columnResizingMode"
                          [columnAutoWidth]="true"
                          [showColumnLines]="true"
                          [showRowLines]="true"
                          [showBorders]="true"
                          [rowAlternationEnabled]="false"
                          [hoverStateEnabled]="true"
                          [wordWrapEnabled]="false"
                          [cellHintEnabled]="true"
                          (onCellPrepared)="onCellPrepared($event)"
                          keyExpr="__lwfBusinessProcessInstanceId"
                          style="height: 100%; "
                          (onEditorPreparing)="datePickerService.onEditorPreparingMethod($event)">
              <dxo-editing mode="cell"
                           [allowUpdating]="true"
                           [allowAdding]="false">
              </dxo-editing>

              <dxo-paging [pageSize]="100"></dxo-paging>
              <dxo-pager [showPageSizeSelector]="__oStateDataSource.length > 0"
                         [allowedPageSizes]="[10, 50 ,100]"
                         [visible]="__oStateDataSource.length > 0"
                         [showNavigationButtons]="true"
                         [showInfo]="true"
                         [displayMode]="'full'">
              </dxo-pager>
              <dxo-sorting mode="multiple"></dxo-sorting>
              <dxo-filter-row [visible]="true"
                              applyFilter="auto"></dxo-filter-row>
              <dxo-header-filter [visible]="true"></dxo-header-filter>
              <div *dxTemplate="let Info of 'cellTemplate'" style="text-align: center; ">
                <dx-button text="..." (onClick)="onInstanceButtonClick($event, Info)">
                </dx-button>
              </div>
            </dx-data-grid>
          </div>

        </div>

        <div id="div-state-right-panel" class="col content" *ngIf="__bStateInstanceRightPanelVisisble">
          <div class="col-lg-12 col-md-12 col-sm-12 padding0px" style="padding-left: 2px; ">
            <div class="col-lg-12 col-md-12 col-sm-12 padding0px" style="height:100%;">
              <div class="col-lg-12 col-md-12 col-sm-12 iconDiv div-ellipsis" style="height:25px; text-align:center;">
                <span title="{{GetStateWorkflowTitle()}}">{{GetStateWorkflowTitle()}}</span>
              </div>

              <div class="col-lg-12 col-md-12 col-sm-12" style="padding:1px;">
                <dx-tab-panel id="state-WF-tabs" [dataSource]="__oWFTabs"
                              [selectedIndex]="selectedTabIndex"
                              [loop]="false"
                              [animationEnabled]="true"
                              [swipeEnabled]="true">
                  <div *dxTemplate="let company of 'title'">
                    <span>{{company.Name}}</span>
                  </div>
                  <div *dxTemplate="let company of 'item'">
                    <div class="tabpanel-item margin0px" [ngClass]="{ 'row': isSingleDataGridinTab(company), 'tab-padding': !isSingleDataGridinTab(company) }">
                      <!-- State Data Field Columns -->
                      <div class="row">
                      <ng-container *ngIf="TabHasFields(company)">
                        <div class="col-md-6" [ngClass]="{'col-12':__bIsFullWidthContent}">
                          <ng-container *ngFor="let item of __oBusinessProcessInstanceCurrentStateDatas; let i = index; let even = even;">
                            <ng-container *ngIf="company.Name == item.TabName && item.GroupName == null && IsField(item)">
                              <div class="WfFields">
                                <ng-container *ngIf="item.DisplayOrder % 2 === 0">
                                  <ng-container *ngTemplateOutlet="StateDataFieldSection; context: {item: item, instanceId: i}">
                                  </ng-container>
                                </ng-container>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                        <div class="col-md-6" [ngClass]="{'col-12':__bIsFullWidthContent}">
                          <ng-container *ngFor="let item of __oBusinessProcessInstanceCurrentStateDatas; let i = index; let even = even;">
                            <ng-container *ngIf="company.Name == item.TabName && item.GroupName == null && IsField(item)">
                              <div class="WfFields">
                                <ng-container *ngIf="item.DisplayOrder % 2 > 0">
                                  <ng-container *ngTemplateOutlet="StateDataFieldSection; context: {item: item, instanceId: i}">
                                  </ng-container>
                                </ng-container>
                              </div>
                            </ng-container>
                          </ng-container>
                        </div>
                      </ng-container>
                      <!-- State Data Full Width Data Types -->
                      <div class="WfGrids col-12">
                        <ng-container *ngFor="let item of __oBusinessProcessInstanceCurrentStateDatas; let i = index; let even = even;">
                          <ng-container *ngIf="item.DataType == 'File Manager' && company.Name == item.TabName && item.IsVisible == 1">
                            <div class="dx-field" style="padding-top:5px;padding-left:2px;">
                              <div class="dx-field-label">
                                {{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
                              </div>
                              <div style="width:100%;float:left" class="padding0px" *ngIf="__bShowFileManager">
                                <FileManager id="filemanager_{{i}}" *ngIf="IsFileManagerReady(item)" [FileSystem]="item.ItemSource" [Directory]="item.DataValue"></FileManager>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="company.Name == item.TabName && item.DataType == 'Rich Text Box' && item.IsStateDataReadOnly == 0">
                            <div class="dx-field" *ngIf="item.DataType =='Rich Text Box' && item.IsVisible == 1" style="padding-top:5px;padding-left:2px;">
                              <div class="dx-field-label" title="{{item.DisplayName}}" style="width: 12%; ">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
                              </div>
                              <div class="dx-field-value Rich_Text_Box_Anchor" style="width: 80.5%; " *ngIf="isEditorDisplay">
                                <div [froalaEditor]="__oFroalaEditorOptions" [(froalaModel)]="item.DataValue"></div>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="company.Name == item.TabName && item.DataType == 'Rich Text Box' && item.IsStateDataReadOnly == 1">
                            <div class="dx-field Rich_Text_Box_ReadOnly" *ngIf="item.DataType =='Rich Text Box' && item.IsVisible == 1" style="padding-top:5px;padding-left:2px;">
                              <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
                              </div>
                              <div class="dx-field-value" *ngIf="isEditorDisplay">
                                <div [froalaEditor]="__oFroalaEditorOptionReadOnly" [(froalaModel)]="item.DataValue" class="FroalaCursor"></div>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="company.Name == item.TabName && item.DataType == 'Qualitative Grid' && item.IsVisible == 1">
                            <app-ScoringQualitativeDetail-Component [__bReadOnly]="item.IsStateDataReadOnly" [__sInstanceId]="item.lwfBusinessProcessInstanceId" [__sStateDataId]="item.lwfBusinessProcessStateDataId" [__sValue]="item.DataValue" [__sDataCaption]="item.DataCaption" [__sQualitativeControlState]="item.ControlState" [__sScoringModel]="item.ScoringModel" [__sTradingCounterparty]="item.TradingCounterparty" [__sQualitativeControl]="item.QualitativeControl" (onInitialized)="InitializeControl($event,item.DataCaption)"></app-ScoringQualitativeDetail-Component>
                          </ng-container>
                          <ng-container *ngIf="company.Name == item.TabName && item.DataType == 'Quantitative Grid' && item.IsVisible == 1">
                            <app-ScoringQuantitativeDetail-Component [__bReadOnly]="item.IsStateDataReadOnly" [__sInstanceId]="item.lwfBusinessProcessInstanceId" [__sStateDataId]="item.lwfBusinessProcessStateDataId" [__sValue]="item.DataValue" [__sDataCaption]="item.DataCaption" [__sQuantitativeControlState]="item.ControlState" [__sScoringModel]="item.ScoringModel" [__sBasePeriod]="item.BasePeriod" [__sPeriod]="item.Period" [__sTradingCounterparty]="item.TradingCounterparty" [__sQuantitativeControl]="item.QuantitativeControl" (onInitialized)="InitializeControl($event,item.DataCaption)"></app-ScoringQuantitativeDetail-Component>
                          </ng-container>
                          <ng-container *ngIf="company.Name == item.TabName && item.DataType == 'Score Analysis' && item.IsVisible == 1">
                            <app-ScoreAnalysis-Component [__bReadOnly]="item.IsStateDataReadOnly" [__sInstanceId]="item.lwfBusinessProcessInstanceId" [__sStateDataId]="item.lwfBusinessProcessStateDataId" [__sValue]="item.DataValue" [__sDataCaption]="item.DataCaption" [__sQuantitativeControlState]="item.ControlState" [__sScoringModel]="item.ScoringModel" [__sBasePeriod]="item.BasePeriod" [__sPeriod]="item.Period" [__sTradingCounterparty]="item.TradingCounterparty" [__sQuantitativeControl]="item.QuantitativeControl" [__sQualitativeControl]="item.QualitativeControl" [__sScoreAnalysisControl]="item.ScoreAnalysisControl" (onInitialized)="InitializeControl($event,item.DataCaption)"></app-ScoreAnalysis-Component>
                          </ng-container>
                          <ng-container *ngIf="company.Name == item.TabName && item.DataType == 'Final Score Analysis' && item.IsVisible == 1">
                            <app-FinalScoreAnalysis-Component [__bReadOnly]="item.IsStateDataReadOnly" [__sInstanceId]="item.lwfBusinessProcessInstanceId" [__sStateDataId]="item.lwfBusinessProcessStateDataId" [__sValue]="item.DataValue" [__sDataCaption]="item.DataCaption" [__sQuantitativeControlState]="item.ControlState" [__sScoringModel]="item.ScoringModel" [__sBasePeriod]="item.BasePeriod" [__sPeriod]="item.Period" [__sTradingCounterparty]="item.TradingCounterparty" [__sQuantitativeControl]="item.QuantitativeControl" [__sQualitativeControl]="item.QualitativeControl" [__sScoreAnalysisControl]="item.ScoreAnalysisControl" [__sFinalScoreControl]="item.FinalScoreControl" (onInitialized)="InitializeControl($event,item.DataCaption)"></app-FinalScoreAnalysis-Component>
                          </ng-container>
                          <ng-container *ngIf="company.Name == item.TabName && item.DataType == 'PowerBI Report' && item.IsVisible == 1">
                            <app-PowerBI-Component [__sInstanceId]="item.lwfBusinessProcessInstanceId" [__sDataCaption]="item.DataCaption" [__sValue]="item.PowerBIReport" [__sStateDataId]="item.lwfBusinessProcessStateDataId" [__sDataTypeParameter]="item.DataTypeParameter" (onInitialized)="InitializePowerBIReport($event,item.DataCaption)"></app-PowerBI-Component>
                          </ng-container>
                          <!--START: Grid control-->
                          <ng-container *ngIf="company.Name == item.TabName && item.DataType == 'Grid' && item.IsVisible == 1">
                            <div class="dx-field" style="padding-top:5px;padding-left:2px;">
                              <div style="width: 5px; float: left; ">
                                <font color="red" *ngIf="item.IsMandatory == 1">*</font>
                              </div>
                              <div style="float: right; width: 99%; " class="padding0px">
                                <dx-data-grid #StateDataGrid class="dashboard-grid" id="stateDataGridControl"
                                              [dataSource]="__oBusinessProcessStateGridDataContext"
                                              [(columns)]="__oGridDatacolumns"
                                              [allowColumnReordering]="false"
                                              [allowColumnResizing]="true"
                                              columnResizingMode="widget"
                                              [columnMinWidth]="100"
                                              [columnAutoWidth]="true"
                                              [showColumnLines]="true"
                                              [showRowLines]="true"
                                              [showBorders]="true"
                                              [rowAlternationEnabled]="false"
                                              [hoverStateEnabled]="true"
                                              [wordWrapEnabled]="false"
                                              [cellHintEnabled]="true"
                                              keyExpr="RowNumber"
                                              (onCellClick)="onCellClick($event)"
                                              (onCellPrepared)="onCellPrepared($event)"
                                              (onKeyDown)="OnKeyDown($event)"
                                              [(selectedRowKeys)]="__oStateDataGridSelectedKeys"
                                              style="min-width:100%;max-width:100%"
                                              (onExporting)="onExporting($event, 'GridDataResult')"
                                              (onEditorPreparing)="datePickerService.onEditorPreparingMethod($event)">
                                  <dxo-editing mode="cell"
                                               [allowUpdating]="true"
                                               [allowAdding]="false">
                                  </dxo-editing>
                                  <dxo-export [enabled]="true" [allowExportSelectedData]="false">

                                  </dxo-export>
                                  <dxo-selection selectAllMode="allPages"
                                                 showCheckBoxesMode="onClick"
                                                 mode="multiple"></dxo-selection>
                                  <dxo-paging [pageSize]="1000"></dxo-paging>
                                  <dxo-pager [showPageSizeSelector]="__oBusinessProcessStateGridDataContext.length > 0"
                                             [allowedPageSizes]="[10, 100 ,1000]"
                                             [showInfo]="true"
                                             [visible]="__oBusinessProcessStateGridDataContext.length > 0"
                                             [showNavigationButtons]="true"
                                             [displayMode]="'full'">
                                  </dxo-pager>
                                  <dxo-sorting mode="multiple"></dxo-sorting>
                                  <dxo-column-chooser mode="select" [enabled]="false" [allowSearch]="true"></dxo-column-chooser>
                                  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
                                  <dxo-filter-row [visible]="true"
                                                  applyFilter="auto"></dxo-filter-row>
                                  <dxo-header-filter [visible]="true"></dxo-header-filter>

                                  <div *dxTemplate="let Info of 'gridCellTemplateTextBox'">
                                    <dx-text-box class="cl-text-box"
                                                 [height]="35" [maxLength]="50" [(value)]="Info.data.DataValue[Info.columnIndex]"></dx-text-box>
                                  </div>

                                  <div *dxTemplate="let Info of 'gridCellTemplateComboBox'">
                                    <dx-select-box id="sb_ItemSource_{{i}}5"
                                                   class="cl-select_box"
                                                   [dataSource]="Info.data.ItemSource[Info.columnIndex]"
                                                   displayExpr="DisplayMember"
                                                   valueExpr="DisplayMember"
                                                   [(value)]="Info.data.DataValue[Info.columnIndex]"
                                                   [searchEnabled]="true"
                                                   itemTemplate="item">
                                      <div *dxTemplate="let data of 'item'">
                                        <div id="WD_ItemSource_{{i}}_DB" style="display:inline-block">{{data.DisplayMember}}</div>
                                      </div>
                                      <dxo-drop-down-options container="#sb_ItemSource_{{i}}5" [hideOnParentScroll]="false"></dxo-drop-down-options>
                                    </dx-select-box>
                                  </div>

                                  <div *dxTemplate="let Info of 'gridCellTemplateAutoComplete'">
                                    <dx-autocomplete class="cl-autocomplete"
                                                     [dataSource]="Info.data.ItemSource[Info.columnIndex]"
                                                     valueExpr="DisplayMember"
                                                     [showClearButton]="true"
                                                     [searchTimeout]="500"
                                                     [(value)]="Info.data.DataValue[Info.columnIndex]"
                                                     (onValueChanged)="GetDataForStateGridACB(Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lwfBusinessProcessStateDataId)"
                                                     (onItemClick)="GetDependentDataForStateGridACB(Info.columnIndex, Info.rowIndex, Info.data.RowNumber, item.lwfBusinessProcessStateDataId, Info.data.QueryResult[Info.columnIndex-1].ColumnName)"
                                                     [(opened)]="__bAutoCompleteOpened"
                                                     (onFocusIn)="StateGridACBonFocusIn(Info.columnIndex,Info.rowIndex,Info.data.RowNumber,$event)"
                                                     [maxItemCount]="30"
                                                     itemTemplate="item">
                                      <div *dxTemplate="let data of 'item'">
                                        <div id="WD_ItemSource_{{i}}_ACB">{{data.DisplayMember}}</div>
                                      </div>
                                    </dx-autocomplete>
                                  </div>


                                  <div *dxTemplate="let Info of 'gridCellTemplateAmount'">
                                    <dx-number-box class="cl-number-box" [step]="0"
                                                   format="#,##0.##" [(value)]="Info.data.DataValue[Info.columnIndex]" style="text-align:right;"></dx-number-box>
                                  </div>

                                  <div *dxTemplate="let Info of 'gridCellTemplateMultiline'">
                                    <dx-text-area class="cl-text-area"
                                                  [height]="35" [maxLength]="5000" [(value)]="Info.data.DataValue[Info.columnIndex]"></dx-text-area>
                                  </div>

                                  <div *dxTemplate="let Info of 'gridCellTemplateDate'">
                                    <app-date-picker class="cl-date-box"
                                                     id="dbDate{{i}}3"
                                                     type="date" [value]="Info.data.DataValue[Info.columnIndex]" displayFormat="dd-MMM-yyyy"
                                                     (onDatePickerValueChanged)="Info.data.DataValue[Info.columnIndex]=$event.value">
                                    </app-date-picker>
                                  </div>

                                  <div *dxTemplate="let Info of 'gridCellTemplateCheckBox'">
                                    <dx-check-box class="cl-check-box"
                                                  [(value)]="Info.data.DataValue[Info.columnIndex]">
                                    </dx-check-box>
                                  </div>

                                  <div *dxTemplate="let Info of 'gridCellTemplate'" style="margin-right: 20px;  ">
                                    <a class="btn btn-sm btn-info" [ngClass]="{'dx-state-disabled' : item.IsEnabled == 1 }" title="Remove" (click)="removeStateGridRow(Info.columnIndex, Info.rowIndex, Info.data.RowNumber)">
                                      <span class="glyphicon glyphicon-trash"></span>
                                    </a>
                                  </div>
                                </dx-data-grid>
                              </div>
                            </div>
                          </ng-container>
                          <!--END: Grid control-->
                          <!--START: Data Grid control-->
                          <ng-container *ngIf="company.Name == item.TabName && item.DataType == 'Data Grid' && item.PositionGridWithFields != 1 && item.IsVisible == 1">
                            <div class="dx-field" style="padding-top:5px;padding-left:2px;">
                              <div style="margin-top:5px;float:right;">
                                <dx-button text="Add Row" hint="Add Row" (onClick)="AddRowForStateGenericDataGrid($event,item.lBusinessProcessInstanceCurrentStateDataId)" [visible]="item.IsAddRowEnabled" style="width:120px;height:25px;"></dx-button>
                              </div>
                              <div class="dx-field-label" title="{{item.DisplayName}}" style="width: 17%; float: left; ">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                              <div style="float: right; width: 99%;margin-top:2px;height:25rem " class="padding0px WfGrid">
                                <ng-container *ngTemplateOutlet="DataGrid; context: {item: item}">
                                </ng-container>
                              </div>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="company.Name == item.TabName && item.DataType =='Content Frame' && (item.IsVisible == 1) && item.IsHalfWidth != 1">
                            <div class="dx-field">
                              <div class="dx-field-label">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                              <iframe [src]="item.SafeUrl" class="ContentFrameFullWidth"></iframe>
                            </div>
                          </ng-container>
                          <!--END: data Grid control-->
                        </ng-container>
                        <ng-container *ngFor="let group of __oStateDataGroup">
                          <fieldset *ngIf="company.Name == group.TabName">
                            <legend>{{group.GroupName}}</legend>
                            <div class="col-lg-6 col-md-6 col-sm-6">
                              <div *ngFor="let item of __oBusinessProcessInstanceCurrentStateDatas; let i= index">
                                <div *ngIf="item.DisplayOrder % 2 === 0 && company.Name == item.TabName && item.GroupName != null && group.GroupName == item.GroupName">

                                  <div class="dx-field" *ngIf="item.DataType =='Dropdown' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
                                    </div>
                                    <div class="dx-field-value" [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
                                      <dx-select-box id="slb_ItemSource_{{i}}_DB"
                                                     class="cl-select_box"
                                                     [dataSource]="item.ItemSource"
                                                     displayExpr="DisplayMember"
                                                     valueExpr="DisplayMember"
                                                     [(value)]="item.DataValue"
                                                     (onSelectionChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"
                                                     [readOnly]="item.IsEnabled || item.IsStateDataReadOnly"
                                                     [searchEnabled]="true"
                                                     [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}"
                                                     itemTemplate="item">
                                        <div *dxTemplate="let data of 'item'">
                                          <div id="WD_ItemSource_{{i}}_DB" style="display:inline-block">{{data.DisplayMember}}</div>
                                        </div>
                                        <dxo-drop-down-options container="#slb_ItemSource_{{i}}_DB" [hideOnParentScroll]="false"></dxo-drop-down-options>
                                      </dx-select-box>
                                      <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px; float:left" [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}"
                                              class="btn btn-info btn-sm clickable" title="{{item.LinkName}}">
                                        <span style="top: -1px; "
                                              [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Mail Attachment' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
                                      <input type="file" [attr.id]="item.lBusinessProcessInstanceCurrentStateDataId" class="hidden" (change)="fileChange($event,item.lBusinessProcessInstanceCurrentStateDataId,item.DataCaption)" />
                                      <label [attr.for]="item.lBusinessProcessInstanceCurrentStateDataId" class="uploadlabel">Attach file</label>
                                      <div>
                                        <button class="downloadLink" title="{{item.DataValue}}">{{item.DataValue}}</button>&nbsp;&nbsp;
                                      </div>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='File Chooser' && (item.IsVisible == 1)"
                                       style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}" [ngClass]="{'Disabled' : item.IsStateDataReadOnly }">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
                                      <input type="file" [attr.id]="item.lBusinessProcessInstanceCurrentStateDataId" class="hidden"
                                             (change)="fileUpload($event,item.lBusinessProcessInstanceCurrentStateDataId,item.DataCaption)"
                                             [ngClass]="{'Disabled' : item.IsStateDataReadOnly }" />
                                      <label [attr.for]="item.lBusinessProcessInstanceCurrentStateDataId" class="uploadlabel"
                                             [ngClass]="{'Disabled' : item.IsStateDataReadOnly }">Choose file</label>
                                      <div *ngFor="let FileDetail of item.FileDetail" class="file_chooser_iniline_flex_display">
                                        <button (click)="DownLoad(item.lBusinessProcessInstanceCurrentStateDataId,FileDetail.FilePath)" class="downloadLink" title="{{FileDetail.FileName}}">{{FileDetail.FileName}}</button>&nbsp;&nbsp;
                                        <button type="button" class="btn btn-default btn-sm" (click)="DeleteFile(item.lBusinessProcessInstanceCurrentStateDataId,FileDetail.FilePath)"
                                                style="border:none;" [ngClass]="{'Disabled' : item.IsStateDataReadOnly }">
                                          <span class="glyphicon glyphicon-trash" style="padding-bottom:7px;"></span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Due Date Specifier' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <table>
                                        <tr>
                                          <td style="width:30%">
                                            <dx-number-box class="cl-number-box" [step]="0"
                                                           format="#,##0.##" [(value)]="item.DueDate" [disabled]="item.IsEnabled || item.IsStateDataReadOnly" style="text-align:right;" (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"></dx-number-box>
                                          </td>
                                          <td style="padding-left:2px;">
                                            <dx-select-box id="slb_ItemSource_{{i}}2"
                                                           class="cl-select_box"
                                                           [dataSource]="item.ItemSource"
                                                           displayExpr="DisplayMember"
                                                           valueExpr="DisplayMember"
                                                           [(value)]="item.DueDateRule"
                                                           (onSelectionChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"
                                                           [readOnly]="item.IsEnabled || item.IsStateDataReadOnly"
                                                           [searchEnabled]="true"
                                                           style="width:100%"
                                                           itemTemplate="item">
                                              <div *dxTemplate="let data of 'item'">
                                                <div id="WD_ItemSource_{{i}}_DB" style="display:inline-block">{{data.DisplayMember}}</div>
                                              </div>
                                              <dxo-drop-down-options container="#slb_ItemSource_{{i}}2" [hideOnParentScroll]="false"></dxo-drop-down-options>
                                            </dx-select-box>
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  </div>


                                  <div class="dx-field" *ngIf="item.DataType =='Reference Data' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <div class="row">
                                        <div class="col-md-8 col-lg-6 col-sm-6 inputBeforebtnCopy">
                                          <dx-text-box class="cl-text-box"
                                                       [height]="30" [readOnly]="item.IsEnabled || item.IsStateDataReadOnly" [visible]="item.ReferenceDataTextBoxVisible" [placeholder]="item.PlaceHolder" [(value)]="item.DataValue"
                                                       (onFocusOut)="ReferenceTextBoxLostFocus(item.lBusinessProcessInstanceCurrentStateDataId)" (onChange)="ReferenceTextBoxLostFocus(item.lBusinessProcessInstanceCurrentStateDataId)"></dx-text-box>
                                          <button (click)="OpenReferenceDataURL(item.lBusinessProcessInstanceCurrentStateDataId)" [ngStyle]="{'visibility':item.ReferenceDataURLVisible ? 'visible':'hidden'}"
                                                  class="downloadLink textRefrence" title="{{item.DataValue}}">
                                            {{item.DataValue}}
                                          </button>
                                        </div>&nbsp;
                                        <div class="col-md-4 col-lg-6 col-sm-6  btnCopyEdit">
                                          <dx-button text="Copy" hint="Copy" (onClick)="copyMessage(item.DataValue,item.lBusinessProcessInstanceCurrentStateDataId)" class="btn-secondary" [visible]="item.IsStateDataReadOnly == 0 && item.IsCopyButtonEnabled == 1"></dx-button>&nbsp;

                                          <dx-button text="Edit" hint="Edit" (onClick)="EditReferenceData(item.lBusinessProcessInstanceCurrentStateDataId)" class="btn-secondary" [visible]="item.IsStateDataReadOnly == 0"></dx-button>
                                        </div>
                                      </div>

                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Multi Select Combo Box' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <dx-tag-box class="dxTagBox" [items]="item.ItemSource"
                                                  [showSelectionControls]="true"
                                                  [searchEnabled]="true"
                                                  valueExpr="DisplayMember"
                                                  displayExpr="DisplayMember"
                                                  [(value)]="item.MultiSelectedItems"
                                                  placeholder="Select ..."
                                                  applyValueMode="instantly"
                                                  [showClearButton]="false"
                                                  [disabled]="item.IsEnabled || item.IsStateDataReadOnly"
                                                  (onValueChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)">
                                      </dx-tag-box>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Search Box' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
                                      <dx-autocomplete class="cl-autocomplete"
                                                       [placeholder]="item.PlaceHolder"
                                                       [dataSource]="item.ItemSource"
                                                       valueExpr="DisplayMember"
                                                       [showClearButton]="true"
                                                       [searchTimeout]="500"
                                                       [(value)]="item.DataValue"
                                                       (onValueChanged)="GetDataForACB(item.lwfBusinessProcessInstanceId,item.lwfBusinessProcessStateDataId,item)"
                                                       (onSelectionChanged)="TextAreaOnChangeACB(item.lwfBusinessProcessInstanceId,item.DataCaption,item,$event)"
                                                       [maxItemCount]="30"
                                                       [disabled]="item.IsEnabled || item.IsStateDataReadOnly"
                                                       [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}"
                                                       itemTemplate="item">
                                        <div *dxTemplate="let data of 'item'">
                                          <div id="WD_ItemSource_{{i}}_ACB">{{data.DisplayMember}}</div>
                                        </div>
                                      </dx-autocomplete>
                                      <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px; float:left" [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}"
                                              class="btn btn-info btn-sm clickable" title="{{item.LinkName}}">
                                        <span style="top: -1px; "
                                              [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Alpha Numeric' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
                                      <dx-text-area class="cl-text-area"
                                                    [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}" [height]="35" [maxLength]="item.TextSize" [readOnly]="item.IsEnabled || item.IsStateDataReadOnly" [placeholder]="item.PlaceHolder" [(value)]="item.DataValue" (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"></dx-text-area>
                                      <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px; float:left" [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}"
                                              class="btn btn-info btn-sm clickable" title="{{item.LinkName}}">
                                        <span style="top: -1px; "
                                              [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Multiline String' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <dx-text-area class="cl-text-area"
                                                    [height]="item.Height" [maxLength]="item.TextSize" [readOnly]="item.IsEnabled || item.IsStateDataReadOnly" [placeholder]="item.PlaceHolder" [(value)]="item.DataValue" (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"></dx-text-area>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Date Picker' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <app-date-picker class="cl-date-box"
                                                       id="dbDate{{i}}1"
                                                       type="date" [value]="item.DataValue" [disabled]="item.IsEnabled || item.IsStateDataReadOnly" placeholder="dd-MMM-yyyy" displayFormat="dd-MMM-yyyy"
                                                       (onDatePickerValueChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption, $event, item)">
                                      </app-date-picker>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Label' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
                                      {{item.DataValue}}
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Numeric/Money' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
                                      <dx-number-box class="cl-number-box" [step]="0"
                                                     [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}" [format]="item.FormatString"
                                                     [ngClass]="{'negativeFontColor' : item.DataValue != null && item.DataValue != undefined && item.DataValue < 0 }" [min]="item.Min" [max]="item.Max" [(value)]="item.DataValue" (onKeyUp)="onKeyPressNumberBoxState($event,item)" (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)" [disabled]="item.IsEnabled  || item.IsStateDataReadOnly" style="text-align:right;"></dx-number-box>
                                      <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px; float:left" [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}"
                                              class="btn btn-info btn-sm clickable" title="{{item.LinkName}}">
                                        <span style="top: -1px; "
                                              [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Check Box' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <dx-check-box class="cl-check-box"
                                                    [(value)]="item.DataValue" [disabled]="item.IsEnabled || item.IsStateDataReadOnly" (onValueChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)">
                                      </dx-check-box>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Dependent Data Label' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}" *ngIf="item.IsDataCaptionVisible == 1">{{item.DisplayName}}</div>
                                    <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
                                      {{item.DataValue}}
                                    </div>
                                  </div>
                                  <div class="dx-field" *ngIf="item.DataType =='Counterparty Tree View' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-value" [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">

                                      <dx-tree-view #stateworkflowTreeView id="trvStateWorkflow{{i}}" [dataSource]="item.ItemSource"
                                                    keyExpr="ID"
                                                    displayExpr="ChildTradingCounterparty"
                                                    itemsExpr="TradingCounterpartyLegalHierarchyOwnershippings"
                                                    expandedExpr="isExpanded"
                                                    selectedExpr="isSelected"
                                                    selectionMode="single"
                                                    focusStateEnabled="false"
                                                    selectByClick="true"
                                                    itemTemplate="cptyTemplate"
                                                    style="border: 1px solid #4F87F6;border-radius: 5px;"
                                                    width="100%"
                                                    height="22rem">
                                        <div *dxTemplate="let cpty of 'cptyTemplate'">
                                          <span title="{{cpty.ChildTradingCounterparty}}">{{cpty.ChildTradingCounterparty}}</span>
                                        </div>
                                      </dx-tree-view>

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="col-lg-6 col-md-6 col-sm-6">
                              <div *ngFor="let item of __oBusinessProcessInstanceCurrentStateDatas; let i= index">
                                <div *ngIf="item.DisplayOrder % 2 > 0 && company.Name == item.TabName && item.GroupName != null && group.GroupName == item.GroupName">

                                  <div class="dx-field" *ngIf="item.DataType =='Dropdown' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
                                      <dx-select-box id="sb_ItemSource_{{i}}3"
                                                     class="cl-select_box"
                                                     [dataSource]="item.ItemSource"
                                                     displayExpr="DisplayMember"
                                                     valueExpr="DisplayMember"
                                                     [(value)]="item.DataValue"
                                                     (onSelectionChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"
                                                     [readOnly]="item.IsEnabled || item.IsStateDataReadOnly"
                                                     [searchEnabled]="true"
                                                     [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}"
                                                     itemTemplate="item">
                                        <div *dxTemplate="let data of 'item'">
                                          <div id="WD_ItemSource_{{i}}_DB" style="display:inline-block">{{data.DisplayMember}}</div>
                                        </div>
                                        <dxo-drop-down-options container="#sb_ItemSource_{{i}}3" [hideOnParentScroll]="false"></dxo-drop-down-options>
                                      </dx-select-box>
                                      <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px;float:left" [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}"
                                              class="btn btn-info btn-sm clickable" title="{{item.LinkName}}">
                                        <span style="top: -1px; "
                                              [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Button' && (item.IsVisible == 1)" style="padding-top:10px;padding-left:2px;">
                                    <div class="dx-field-value" style="text-align: right;">
                                      <a *ngIf="item.DataType == 'Button' && (item.IsVisible == 1 || item.IsStateDataVisible)" class="btn btn-info btn-sm clickable" title="Add new" (click)="addStateGridNewRow()">
                                        <span class="dx-icon dx-icon-add" style="top: -1px; "></span>
                                      </a>
                                    </div>
                                  </div>



                                  <div class="dx-field" *ngIf="item.DataType =='Mail Attachment' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
                                      <input type="file" [attr.id]="item.lBusinessProcessInstanceCurrentStateDataId" class="hidden" (change)="fileChange($event,item.lBusinessProcessInstanceCurrentStateDataId,item.DataCaption)" />
                                      <label [attr.for]="item.lBusinessProcessInstanceCurrentStateDataId" class="uploadlabel">Attach file</label>
                                      <div>
                                        <button class="downloadLink" title="{{item.DataValue}}">{{item.DataValue}}</button>&nbsp;&nbsp;
                                      </div>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='File Chooser' && (item.IsVisible == 1)"
                                       style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}" [ngClass]="{'Disabled' : item.IsStateDataReadOnly }">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
                                      <input type="file" [attr.id]="item.lBusinessProcessInstanceCurrentStateDataId" class="hidden"
                                             (change)="fileUpload($event,item.lBusinessProcessInstanceCurrentStateDataId,item.DataCaption)"
                                             [ngClass]="{'Disabled' : item.IsStateDataReadOnly }" />
                                      <label [attr.for]="item.lBusinessProcessInstanceCurrentStateDataId" class="uploadlabel"
                                             [ngClass]="{'Disabled' : item.IsStateDataReadOnly }">Choose file</label>
                                      <div *ngFor="let FileDetail of item.FileDetail" class="file_chooser_iniline_flex_display">
                                        <button (click)="DownLoad(item.lBusinessProcessInstanceCurrentStateDataId,FileDetail.FilePath)" class="downloadLink" title="{{FileDetail.FileName}}">{{FileDetail.FileName}}</button>&nbsp;&nbsp;
                                        <button type="button" class="btn btn-default btn-sm" (click)="DeleteFile(item.lBusinessProcessInstanceCurrentStateDataId,FileDetail.FilePath)"
                                                style="border:none;" [ngClass]="{'Disabled' : item.IsStateDataReadOnly }">
                                          <span class="glyphicon glyphicon-trash" style="padding-bottom:7px;"></span>
                                        </button>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Due Date Specifier' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <table>
                                        <tr>
                                          <td style="width:30%">
                                            <dx-number-box class="cl-number-box" [step]="0"
                                                           format="#,##0.##" [(value)]="item.DueDate" [disabled]="item.IsEnabled || item.IsStateDataReadOnly" style="text-align:right;"
                                                           (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)">
                                            </dx-number-box>
                                          </td>
                                          <td style="padding-left:2px;">
                                            <dx-select-box id="sb_ItemSource_{{i}}4"
                                                           class="cl-select_box"
                                                           [dataSource]="item.ItemSource"
                                                           displayExpr="DisplayMember"
                                                           valueExpr="DisplayMember"
                                                           [(value)]="item.DueDateRule"
                                                           (onSelectionChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"
                                                           [readOnly]="item.IsEnabled || item.IsStateDataReadOnly"
                                                           [searchEnabled]="true"
                                                           style="width:100%"
                                                           itemTemplate="item">
                                              <div *dxTemplate="let data of 'item'">
                                                <div id="WD_ItemSource_{{i}}_DB" style="display:inline-block">{{data.DisplayMember}}</div>
                                              </div>
                                              <dxo-drop-down-options container="#sb_ItemSource_{{i}}4" [hideOnParentScroll]="false"></dxo-drop-down-options>
                                            </dx-select-box>
                                          </td>
                                        </tr>
                                      </table>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Reference Data' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <div class="row">
                                        <div class="col-md-8 col-lg-6 col-sm-6 inputBeforebtnCopy">
                                          <dx-text-box class="cl-text-box"
                                                       [height]="30" [readOnly]="item.IsEnabled || item.IsStateDataReadOnly" [visible]="item.ReferenceDataTextBoxVisible" [placeholder]="item.PlaceHolder" [(value)]="item.DataValue"
                                                       (onFocusOut)="ReferenceTextBoxLostFocus(item.lBusinessProcessInstanceCurrentStateDataId)" (onChange)="ReferenceTextBoxLostFocus(item.lBusinessProcessInstanceCurrentStateDataId)"></dx-text-box>
                                          <button (click)="OpenReferenceDataURL(item.lBusinessProcessInstanceCurrentStateDataId)" [ngStyle]="{'visibility':item.ReferenceDataURLVisible ? 'visible':'hidden'}"
                                                  class="downloadLink textRefrence" title="{{item.DataValue}}">
                                            {{item.DataValue}}
                                          </button>
                                        </div>&nbsp;
                                        <div class="col-md-4 col-lg-6 col-sm-6  btnCopyEdit">
                                          <dx-button text="Copy" hint="Copy" (onClick)="copyMessage(item.DataValue,item.lBusinessProcessInstanceCurrentStateDataId)" class="btn-secondary" [visible]="item.IsStateDataReadOnly == 0 && item.IsCopyButtonEnabled == 1"></dx-button>&nbsp;

                                          <dx-button text="Edit" hint="Edit" (onClick)="EditReferenceData(item.lBusinessProcessInstanceCurrentStateDataId)" class="btn-secondary" [visible]="item.IsStateDataReadOnly == 0"></dx-button>
                                        </div>
                                      </div>

                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Multi Select Combo Box' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <dx-tag-box class="dxTagBox" [items]="item.ItemSource"
                                                  [showSelectionControls]="true"
                                                  [searchEnabled]="true"
                                                  valueExpr="DisplayMember"
                                                  displayExpr="DisplayMember"
                                                  [(value)]="item.MultiSelectedItems"
                                                  placeholder="Select ..."
                                                  applyValueMode="instantly"
                                                  [showClearButton]="false"
                                                  [disabled]="item.IsEnabled || item.IsStateDataReadOnly"
                                                  (onValueChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)">
                                      </dx-tag-box>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Search Box' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
                                      <dx-autocomplete class="cl-autocomplete"
                                                       [placeholder]="item.PlaceHolder"
                                                       [dataSource]="item.ItemSource"
                                                       valueExpr="DisplayMember"
                                                       [showClearButton]="true"
                                                       [searchTimeout]="500"
                                                       [(value)]="item.DataValue"
                                                       (onValueChanged)="GetDataForACB(item.lwfBusinessProcessInstanceId,item.lwfBusinessProcessStateDataId,item)"
                                                       (onSelectionChanged)="TextAreaOnChangeACB(item.lwfBusinessProcessInstanceId,item.DataCaption,item,$event)"
                                                       [maxItemCount]="30"
                                                       [disabled]="item.IsEnabled || item.IsStateDataReadOnly"
                                                       [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}"
                                                       itemTemplate="item">
                                        <div *dxTemplate="let data of 'item'">
                                          <div id="WD_ItemSource_{{i}}_ACB">{{data.DisplayMember}}</div>
                                        </div>
                                      </dx-autocomplete>
                                      <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px;float:left" [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}"
                                              class="btn btn-info btn-sm clickable" title="{{item.LinkName}}">
                                        <span style="top: -1px; "
                                              [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Alpha Numeric' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
                                      <dx-text-area class="cl-text-area"
                                                    [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}" [height]="35" [maxLength]="item.TextSize" [readOnly]="item.IsEnabled || item.IsStateDataReadOnly" [placeholder]="item.PlaceHolder" [(value)]="item.DataValue" (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"></dx-text-area>
                                      <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px;float:left" [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}"
                                              class="btn btn-info btn-sm clickable" title="{{item.LinkName}}">
                                        <span style="top: -1px; "
                                              [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Multiline String' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <dx-text-area class="cl-text-area"
                                                    [height]="item.Height" [maxLength]="item.TextSize" [readOnly]="item.IsEnabled || item.IsStateDataReadOnly" [placeholder]="item.PlaceHolder" [(value)]="item.DataValue" (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"></dx-text-area>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Date Picker' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <app-date-picker class="cl-date-box"
                                                       id="dbDate{{i}}2"
                                                       type="date" [value]="item.DataValue" [disabled]="item.IsEnabled || item.IsStateDataReadOnly" placeholder="dd-MMM-yyyy" displayFormat="dd-MMM-yyyy"
                                                       (onDatePickerValueChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption, $event, item)">
                                      </app-date-picker>
                                    </div>
                                  </div>



                                  <div class="dx-field" *ngIf="item.DataType =='Label' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
                                      {{item.DataValue}}
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Numeric/Money' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value" [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
                                      <dx-number-box class="cl-number-box" [step]="0"
                                                     [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}" [format]="item.FormatString" [ngClass]="{'negativeFontColor' : item.DataValue != null && item.DataValue != undefined && item.DataValue < 0 }" [min]="item.Min" [max]="item.Max" [(value)]="item.DataValue" (onKeyUp)="onKeyPressNumberBoxState($event,item)" (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DisplayName)" [disabled]="item.IsEnabled || item.IsStateDataReadOnly" style="text-align:right;"></dx-number-box>
                                      <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px;float:left" [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}"
                                              class="btn btn-info btn-sm clickable" title="{{item.LinkName}}">
                                        <span style="top: -1px; "
                                              [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
                                      </button>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Check Box' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
                                    <div class="dx-field-value">
                                      <dx-check-box class="cl-check-box"
                                                    [(value)]="item.DataValue" [disabled]="item.IsEnabled || item.IsStateDataReadOnly" (onValueChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)">
                                      </dx-check-box>
                                    </div>
                                  </div>

                                  <div class="dx-field" *ngIf="item.DataType =='Dependent Data Label' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-label" title="{{item.DisplayName}}" *ngIf="item.IsDataCaptionVisible == 1">{{item.DisplayName}}</div>
                                    <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
                                      {{item.DataValue}}
                                    </div>
                                  </div>
                                  <div class="dx-field" *ngIf="item.DataType =='Counterparty Tree View' && (item.IsVisible == 1)" style="padding-top:5px;padding-left:2px;">
                                    <div class="dx-field-value" [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
                                      <dx-tree-view #stateworkflowTreeView id="trvStateWorkflow{{i}}" [dataSource]="item.DataValue"
                                                    keyExpr="ID"
                                                    displayExpr="ChildTradingCounterparty"
                                                    itemsExpr="TradingCounterpartyLegalHierarchyOwnershippings"
                                                    expandedExpr="isExpanded"
                                                    selectedExpr="isSelected"
                                                    selectionMode="single"
                                                    focusStateEnabled="false"
                                                    selectByClick="true"
                                                    itemTemplate="cptyTemplate"
                                                    style="border: 1px solid #4F87F6;border-radius: 5px;"
                                                    width="100%"
                                                    height="22rem">
                                        <div *dxTemplate="let cpty of 'cptyTemplate'">
                                          <span title="{{cpty.ChildTradingCounterparty}}">{{cpty.ChildTradingCounterparty}}</span>
                                        </div>
                                      </dx-tree-view>

                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </fieldset>
                        </ng-container>
                      </div>
                      <div class="col-lg-8" *ngIf="company.Name == 'Comment'">
                        <div class="dx-field" style="padding-top:5px;padding-left:2px;">
                          <div class="dx-field-label" title="Comment">Comments</div>
                          <div class="dx-field-value">
                            <dx-text-area class="cl-text-area"
                                          [height]="150" [maxLength]="5000" [(value)]="__sInstanceComment" [placeholder]="Comment"></dx-text-area>
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </dx-tab-panel>
                <div id="div-Audit-info" class="padding0px">
                  <span>{{__sAuditInfo}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-12 col-md-12 col-sm-12 padding0px" *ngIf="__bStateInstanceRightPanelVisisble" style="padding-left: 2px; ">
            <div class="col-lg-12 col-md-12 col-sm-12 div-border padding0px" style="height:35px; overflow-x:auto;">
              <div class="col-lg-2 col-md-2 col-sm-2" *ngFor="let item of __oBusinessProcessStateActions; let i = index"
                   style="padding:4px 2px 0 2px; float:right; padding-top:4px;">
                <dx-button [text]="item.wfBusinessProcessRuleAction" [hint]="item.wfBusinessProcessRuleAction"
                           (onClick)="ExecuteUserAction(item)" style="width:100%;height:25px;padding:0px !important"></dx-button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div id="divStatelessWF" *ngIf="__bStatelessWorkflowVisible" class="col content">
      <div class="col-lg-12 col-md-12 col-sm-12 padding0px">
        <div class="col-lg-12 col-md-12 col-sm-12 iconDiv div-ellipsis" style="height:25px; padding-left: 5px; ">
          <span title="{{__oBusinessProcessDefinitionName}}" *ngIf="!hideDashboardMenu">{{__oBusinessProcessDefinitionName}}</span>
        </div>
      </div>

      <div id="divStatelessWorkflow" *ngIf="!__bStatelessParentContainer" class="col-lg-12 col-md-12 col-sm-12 padding0px">
        <app-statelessworkflow (onInitialized)="InitializeNonParent($event, __oWFBusinessProcessDefinition.lwfBusinessProcessDefinitionId)" [__bIsOpenedThroughURL]="__bIsOpenedThroughURL"
                               [__sIsFilterApplied]="__sIsFilterApplied" [__sParam]="__sParam" [__sBusinessProcessName]="__oBusinessProcessDefinitionName" [__bIsChild]="false">

        </app-statelessworkflow>
      </div>


      <div id="divStatelessParentContainer" *ngIf="__bStatelessParentContainer" class="col-lg-12 col-md-12 col-sm-12 padding0px"
           style="margin-top: 2px; ">
        <dx-tab-panel [dataSource]="__lStatelessWorkflowTabs"
                      [selectedIndex]="__TPSelectedIndex"
                      [loop]="false"
                      [animationEnabled]="false"
                      [swipeEnabled]="false"
                      [selectedItem]="__TPSelectedItem"
                      (onSelectionChanged)="workflowChildTabSelectionChanged($event)" >

          <div *dxTemplate="let tab of 'title'">
            <span>{{tab.wfBusinessProcessStatelessTab + ' (' + tab.ItemCount + ')' }}</span>
          </div>
          <div *dxTemplate="let info of 'item'">
            <app-statelessworkflow (onInitialized)="Initialize($event, info.lwfBusinessProcessTabDefinitionId)" [__bIsOpenedThroughURL]="__bIsOpenedThroughURL"
                                   [__sIsFilterApplied]="__sIsFilterApplied" [__sParam]="__sParam" [__sBusinessProcessName]="__oBusinessProcessDefinitionName" [__bIsChild]="true">

            </app-statelessworkflow>
          </div>

        </dx-tab-panel>


      </div>

    </div>


  </div>
</div>

<dx-popup [visible]="__bIsDataGridAddRowViaPopup||__bIsDataGridViewViaPopup" (visibleChange)="__bIsDataGridAddRowViaPopup || (__bIsDataGridViewViaPopup = $event)"
          title="Add New Row"
          [wrapperAttr]="{ class: 'popupSample' }"
          class="popup"
          [hideOnOutsideClick]="false"
          (onHiding)="ResetDataGridPopup()"
          [showTitle]="true"
          width="50vw"
          height="auto" maxheight="80vh">
  <div class="AddRowPopupContent">
    <div class="AddRowPopupFields">
      <ng-container *ngIf="__bIsDataGridAddRowViaPopup||__bIsDataGridViewViaPopup">
        <dx-scroll-view style="min-height:40vh">
          <div *ngFor="let item of getDataGridPopupVisibleItems();let i = index;" class="col-12">
            <div class="dx-field" *ngIf="item.editCellTemplate != null">
              <div class="dx-field-label">
                {{item.caption}}<span style="color:red" *ngIf="item.mandatory;">*</span>
              </div>
              <div class="dx-field-value">


                <div *ngIf="item.editCellTemplate == 'gridCellTemplateTextBox'">
                  <dx-text-box class="cl-text-box"
                               id="textbox_{{oDataGridAddRowPopupItemSource.RowNumber}}6"
                               [maxLength]="oDataGridAddRowPopupItemSource.TextSize[i+1]"
                               [disabled]="!item.allowEditing"
                               (onValueChanged)="StateGenericDataGridColumnValueChanged(i+1, 0, oDataGridAddRowPopupItemSource.RowNumber, oDataGridAddRowPopupDataContext.lwfBusinessProcessStateDataId,$event)"
                               [(value)]="oDataGridAddRowPopupItemSource.DataValue[i+1]">
                  </dx-text-box>

                </div>

                <div *ngIf="item.editCellTemplate == 'gridCellTemplateCheckBox'">
                  <dx-check-box class="cl-check-box"
                                id="checkbox_{{oDataGridAddRowPopupItemSource.RowNumber}}6"
                                [disabled]="!item.allowEditing"
                                [(value)]="oDataGridAddRowPopupItemSource.DataValue[i+1]"
                                (onValueChanged)="StateGenericDataGridColumnValueChanged(i+1, 0, oDataGridAddRowPopupItemSource.RowNumber, oDataGridAddRowPopupDataContext.lwfBusinessProcessStateDataId,$event)">
                  </dx-check-box>
                </div>

                <div *ngIf="item.editCellTemplate == 'gridCellTemplateComboBox'">
                  <dx-select-box id="selectbpx_{{oDataGridAddRowPopupItemSource.RowNumber}}{{i}}6"
                                 class="cl-select_box"
                                 [disabled]="!item.allowEditing"
                                 [dataSource]="oDataGridAddRowPopupItemSource.ItemSource[i+1]"
                                 displayExpr="DisplayMember"
                                 valueExpr="DisplayMember"
                                 (onValueChanged)="StateGenericDataGridColumnValueChanged(i+1, 0, oDataGridAddRowPopupItemSource.RowNumber,oDataGridAddRowPopupDataContext.lwfBusinessProcessStateDataId,$event)"
                                 [(value)]="oDataGridAddRowPopupItemSource.DataValue[i+1]"
                                 [searchEnabled]="true"
                                 itemTemplate="item">
                    <dxo-drop-down-options container="#selectbpx_{{oDataGridAddRowPopupItemSource.RowNumber}}{{i}}6" [hideOnParentScroll]="false"></dxo-drop-down-options>
                    <div *dxTemplate="let data of 'item'">
                      <div id="WD_ItemSource_{{i}}_DB" style="display:inline-block">{{data.DisplayMember}}</div>
                    </div>
                  </dx-select-box>
                </div>

                <div *ngIf="item.editCellTemplate == 'gridCellTemplateAutoComplete'">
                  <dx-autocomplete class="cl-autocomplete"
                                   id="acb_{{oDataGridAddRowPopupItemSource.RowNumber}}6"
                                   [dataSource]="oDataGridAddRowPopupItemSource.ItemSource[i+1]"
                                   valueExpr="DisplayMember"
                                   [disabled]="!item.allowEditing"
                                   [showClearButton]="true"
                                   [searchTimeout]="500"
                                   [(value)]="oDataGridAddRowPopupItemSource.DataValue[i+1]"
                                   (onValueChanged)="GetDataForStateGenericDataGridACB(i+1, 0, oDataGridAddRowPopupItemSource.RowNumber,oDataGridAddRowPopupDataContext.lwfBusinessProcessStateDataId,$event)"
                                   (onSelectionChanged)="StateGenericDataGridColumnValueChangedACB(i+1, 0, oDataGridAddRowPopupItemSource.RowNumber,oDataGridAddRowPopupDataContext.lwfBusinessProcessStateDataId,$event)"
                                   (onFocusIn)="StateGenericDataGridACBonFocusIn(i+1,0,oDataGridAddRowPopupItemSource.RowNumber,oDataGridAddRowPopupDataContext.lwfBusinessProcessStateDataId,$event)"
                                   [maxItemCount]="30"
                                   itemTemplate="item">
                    <div *dxTemplate="let data of 'item'">
                      <div id="WD_ItemSource_{{i}}_ACB">{{data.DisplayMember}}</div>
                    </div>
                  </dx-autocomplete>
                </div>

                <div *ngIf="item.editCellTemplate == 'gridCellTemplateAmount'">

                  <dx-number-box class="cl-number-box"
                                 id="numberbox_{{oDataGridAddRowPopupItemSource.RowNumber}}6"
                                 [step]="0"
                                 [disabled]="!item.allowEditing"
                                 [format]="oDataGridAddRowPopupItemSource.NumberFormat[i+1]"
                                 (onValueChanged)="StateGenericDataGridColumnValueChanged(i+1, 0, oDataGridAddRowPopupItemSource.RowNumber,oDataGridAddRowPopupDataContext.lwfBusinessProcessStateDataId,$event)"
                                 [min]="oDataGridAddRowPopupItemSource.MinNum[i+1]"
                                 [max]="oDataGridAddRowPopupItemSource.MaxNum[i+1]"
                                 (onKeyUp)="onKeyPressNumberBoxStateGenericDataGrid($event,i+1, 0, oDataGridAddRowPopupItemSource.RowNumber,oDataGridAddRowPopupDataContext.lwfBusinessProcessStateDataId)"
                                 [(value)]="oDataGridAddRowPopupItemSource.DataValue[i+1]">
                  </dx-number-box>

                </div>

                <div *ngIf="item.editCellTemplate == 'gridCellTemplateMultiline'">
                  <dx-text-area class="cl-text-area"
                                id="textarea_{{oDataGridAddRowPopupItemSource.RowNumber}}6"
                                [autoResizeEnabled]="true"
                                [minHeight]="35"
                                [disabled]="!item.allowEditing"
                                [maxHeight]="200"
                                [maxLength]="5000" [(value)]="oDataGridAddRowPopupItemSource.DataValue[i+1]"
                                (onValueChanged)="StateGenericDataGridColumnValueChanged(i+1, 0, oDataGridAddRowPopupItemSource.RowNumber,oDataGridAddRowPopupDataContext.lwfBusinessProcessStateDataId,$event)">
                  </dx-text-area>
                </div>

                <div *ngIf="item.editCellTemplate == 'gridCellTemplateDate'">
                  <app-date-picker id="date_{{oDataGridAddRowPopupItemSource.RowNumber}}6"
                                   class="cl-date-box"
                                   type="date"
                                   [disabled]="!item.allowEditing"
                                   [(value)]="oDataGridAddRowPopupItemSource.DataValue[i+1]"
                                   (onDatePickerValueChanged)="handleDateValueChange($event, i+1)"
                                   displayFormat="dd-MMM-yyyy"
                                   (onDatePickerValueChanged)="StateGenericDataGridColumnValueChanged(i+1, 0, oDataGridAddRowPopupItemSource.RowNumber,oDataGridAddRowPopupDataContext.lwfBusinessProcessStateDataId,$event)">
                  </app-date-picker>
                </div>

                <div *ngIf="item.editCellTemplate == 'gridCellTemplateMultiSelect'">
                  <dx-tag-box id="tagebox_{{oDataGridAddRowPopupItemSource.RowNumber}}6"
                              class="dxTagBox" [items]="oDataGridAddRowPopupItemSource.ItemSource[i+1]"
                              [showSelectionControls]="true"
                              [searchEnabled]="true"
                              [disabled]="!item.allowEditing"
                              valueExpr="DisplayMember"
                              displayExpr="DisplayMember"
                              [(value)]="oDataGridAddRowPopupItemSource.MultiSelectedItems[i+1]"
                              placeholder="Select ..."
                              applyValueMode="instantly"
                              [showClearButton]="false"
                              (onValueChanged)="StateGenericDataGridColumnValueChangedTB(i+1, 0, oDataGridAddRowPopupItemSource.RowNumber,oDataGridAddRowPopupDataContext.lwfBusinessProcessStateDataId,$event)">
                  </dx-tag-box>
                </div>
              </div>
            </div>
          </div>
        </dx-scroll-view>
      </ng-container>
    </div>
    <div class="row">
      <div class="col AddRowPopupButtonRow">
        <dx-button *ngIf="__bIsDataGridAddRowViaPopup"
                   text="Cancel"
                   (onClick)="DataGridAddPopupCancel()">
        </dx-button>
        <dx-button text="Ok"
                   (onClick)="DataGridAddPopupOK()">
        </dx-button>
      </div>
    </div>
  </div>
</dx-popup>
<!-- Template for Data grid to reduce code duplication -->
<ng-template #DataGrid let-item="item">
  <dx-data-grid #GridStatelessInstances [attr.id]="item.lBusinessProcessInstanceCurrentStateDataId" class="dashboard-grid"
                [dataSource]="item.ItemSource" [masterDetail]="__oStateGenericDataGridMasterDetailOption"
                [(columns)]="item.StateDataGridColumns" [allowColumnReordering]="false" [allowColumnResizing]="true"
                columnResizingMode="widget" [columnMinWidth]="100" [columnAutoWidth]="true" [showColumnLines]="true"
                [showRowLines]="true" [showBorders]="true" [rowAlternationEnabled]="false" [hoverStateEnabled]="true"
                [wordWrapEnabled]="false" [cellHintEnabled]="true" keyExpr="RowNumber" (onCellPrepared)="onCellPrepared($event)"
                style="min-width:100%;max-width:100%;height:100%;"
                (onRowPrepared)="onRowPrepared($event,item.lwfBusinessProcessStateDataId)"
                (onCellClick)="onGenericDataGridCellClick($event,item.lwfBusinessProcessStateDataId)"
                (onInitialized)="GetStateDataGridWidgetInstance($event)"
                (onExporting)="onExporting($event, 'GridDataResult')"
                (onEditorPreparing)="datePickerService.onEditorPreparingMethod($event)">
    <dxo-export [enabled]="true" [allowExportSelectedData]="false">
    </dxo-export>
    <dxo-editing mode="cell" [allowUpdating]="true" [allowAdding]="false">
      <dxo-texts [confirmDeleteMessage]="null"></dxo-texts>
    </dxo-editing>
    <dxo-paging [pageSize]="1000"></dxo-paging>
    <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[10, 100 ,1000]" [showInfo]="true"
               [visible]="item.ItemSource != undefined && item.ItemSource.length > 0" [showNavigationButtons]="true"
               [displayMode]="'full'">
    </dxo-pager>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-column-chooser mode="select" [enabled]="false" [allowSearch]="true"></dxo-column-chooser>
    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
    <dxo-filter-row [visible]="true" applyFilter="auto"></dxo-filter-row>
    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <div *dxTemplate="let Info of 'gridCellTemplateTextBox'">
      <dx-text-box class="cl-text-box" [height]="35" [maxLength]="Info.data.TextSize[Info.columnIndex]"
                   (onValueChanged)="StateGenericDataGridColumnValueChanged(Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lwfBusinessProcessStateDataId,$event)"
                   [(value)]="Info.data.DataValue[Info.columnIndex]"></dx-text-box>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateComboBox'">
      <dx-select-box id="sb_ItemSource_{{Info?.rowIndex}}_DB"
                     class="cl-select_box" [dataSource]="Info.data.ItemSource[Info.columnIndex]"
                     displayExpr="DisplayMember" valueExpr="DisplayMember"
                     (onSelectionChanged)="StateGenericDataGridColumnValueChanged(Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lwfBusinessProcessStateDataId,$event)"
                     [(value)]="Info.data.DataValue[Info.columnIndex]" [searchEnabled]="true" itemTemplate="item">
        <div *dxTemplate="let data of 'item'">
          <div id="WD_ItemSource_{{Info?.rowIndex}}_DB" style="display:inline-block">{{data.DisplayMember}}</div>
        </div>
      </dx-select-box>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateAutoComplete'">
      <dx-autocomplete class="cl-autocomplete" [dataSource]="Info.data.ItemSource[Info.columnIndex]"
                       valueExpr="DisplayMember" [showClearButton]="true" [searchTimeout]="500"
                       [(value)]="Info.data.DataValue[Info.columnIndex]"
                       (onValueChanged)="GetDataForStateGenericDataGridACB(Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lwfBusinessProcessStateDataId,$event)"
                       (onSelectionChanged)="StateGenericDataGridColumnValueChangedACB(Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lwfBusinessProcessStateDataId,$event)"
                       [(opened)]="Info.data.Opened[Info.columnIndex]"
                       (onFocusIn)="StateGenericDataGridACBonFocusIn(Info.columnIndex,Info.rowIndex,Info.data.RowNumber,item.lwfBusinessProcessStateDataId,$event)"
                       [maxItemCount]="30" itemTemplate="item">
        <div *dxTemplate="let data of 'item'">
          <div id="WD_ItemSource_{{Info?.rowIndex}}_ACB">{{data.DisplayMember}}</div>
        </div>
      </dx-autocomplete>
    </div>


    <div *dxTemplate="let Info of 'gridCellTemplateAmount'">
      <dx-number-box class="cl-number-box" [step]="0" [format]="Info.data.NumberFormat[Info.columnIndex]"
                     (onValueChanged)="StateGenericDataGridColumnValueChanged(Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lwfBusinessProcessStateDataId,$event)"
                     [min]="Info.data.MinNum[Info.columnIndex]" [max]="Info.data.MaxNum[Info.columnIndex]"
                     (onKeyUp)="onKeyPressNumberBoxStateGenericDataGrid($event,Info.data,Info.columnIndex,Info.rowIndex,item.lBusinessProcessInstanceCurrentStateDataId)"
                     [(value)]="Info.data.DataValue[Info.columnIndex]" style="text-align:right;"></dx-number-box>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateMultiline'">
      <dx-text-area class="cl-text-area" [height]="35" [maxLength]="Info.data.TextSize[Info.columnIndex]"
                    (onChange)="StateGenericDataGridColumnValueChanged(Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lwfBusinessProcessStateDataId,$event)"
                    [(value)]="Info.data.DataValue[Info.columnIndex]"></dx-text-area>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateDate'">
      <app-date-picker id="dbDate{{Info.columnIndex}}_{{Info.rowIndex}}" class="cl-date-box" type="date" [value]="Info.data.DataValue[Info.columnIndex]"
                       (onDatePickerValueChanged)="StateGenericDataGridColumnValueChanged(Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lwfBusinessProcessStateDataId,$event, Info.data.DataValue)"
                       displayFormat="dd-MMM-yyyy">
      </app-date-picker>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateCheckBox'">
      <dx-check-box class="cl-check-box" [(value)]="Info.data.DataValue[Info.columnIndex]"
                    (onValueChanged)="StateGenericDataGridColumnValueChanged(Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lwfBusinessProcessStateDataId,$event)">
      </dx-check-box>
    </div>


    <div *dxTemplate="let Info of 'gridCellTemplateActionSingle'" align="center">
      <a class="btn btn-sm btn-info" title="Remove" *ngIf="item.IsDeleteRowEnabled == 1"
         (click)="RemoveGenericStateDataGridRow(Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lBusinessProcessInstanceCurrentStateDataId)">
        <span class="glyphicon glyphicon-trash"></span>
      </a>
      <dx-button *ngIf="item.IsViewViaPopup == 1" text="View" hint="View the row in a popup" (onClick)="DataGridViewPopupToggle(item.lwfBusinessProcessStateDataId, Info.rowIndex)"></dx-button>
      <dx-button text="{{item.wfBusinessProcessStateDataGridActions[0].wfBusinessProcessStateDataGridAction1}}" hint="{{item.wfBusinessProcessStateDataGridActions[0].wfBusinessProcessStateDataGridAction1}}"
                 (onClick)="ExecuteStateDataGridUserAction(Info.data.RowNumber, item, $event)" *ngIf="item.IsDeleteRowEnabled != 1 && item.wfBusinessProcessStateDataGridActions.length == 1"></dx-button>
    </div>
    <div *dxTemplate="let Info of 'gridCellTemplateActionMulti'" align="center">
      <dx-drop-down-button [splitButton]="false"
                           [useSelectMode]="false"
                           icon="preferences"
                           class="btn-within-grid-multi-function-icon"
                           [dropDownOptions]="{ width: 150 }"
                           [items]="__oDGStateActionsCog[item.lwfBusinessProcessStateDataId]"
                           displayExpr="name"
                           keyExpr="id"
                           (onItemClick)="ExecuteStateDataGridAction($event.itemData.name,$event, item, Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lBusinessProcessInstanceCurrentStateDataId)">
      </dx-drop-down-button>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateMultiSelect'">
      <dx-tag-box class="dxTagBox" [items]="Info.data.ItemSource[Info.columnIndex]" [showSelectionControls]="true"
                  [searchEnabled]="true" valueExpr="DisplayMember" displayExpr="DisplayMember"
                  [(value)]="Info.data.MultiSelectedItems[Info.columnIndex]" placeholder="Select ..." applyValueMode="instantly"
                  [showClearButton]="false"
                  (onValueChanged)="StateGenericDataGridColumnValueChanged(Info.columnIndex, Info.rowIndex, Info.data.RowNumber,item.lwfBusinessProcessStateDataId,$event)"
                  [(opened)]="gridBoxValueStateDataGrid">
      </dx-tag-box>
    </div>
    <div *dxTemplate="let Info of 'gridCellTemplateMultilineReadOnly'">
      <dx-text-area class="cl-text-area" [height]="35" [disabled]="true" [readOnly]="true"
                    [value]="Info.data.DataValue[Info.columnIndex]"></dx-text-area>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateDateReadOnly'">
      <app-date-picker id="dbDate{{Info.columnIndex}}_{{Info.rowIndex}}1" class="cl-date-box" type="date" [disabled]="true" [value]="Info.data.DataValue[Info.columnIndex]"
                       displayFormat="dd-MMM-yyyy" (onDatePickerValueChanged)="Info.data.DataValue[Info.columnIndex]=$event.value">
      </app-date-picker>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateCheckBoxReadOnly'">
      <dx-check-box class="cl-check-box" [disabled]="true" [value]="Info.data.DataValue[Info.columnIndex]">
      </dx-check-box>
    </div>
    <div *dxTemplate="let Info of 'gridCellTemplateAmountReadOnly'">
      <dx-number-box class="cl-number-box" [step]="0" [disabled]="true" format="#,##0.##"
                     [value]="Info.data.DataValue[Info.columnIndex]" style="text-align:right;"></dx-number-box>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateMultilineInvisible'">
      <dx-text-area class="cl-text-area" [disabled]="true" [height]="35" [readOnly]="true"
                    [value]="calculateCellValue(Info.columnIndex)"></dx-text-area>
    </div>

    <div *dxTemplate="let Info of 'gridCellTemplateURLReadOnly'">
      <a title="{{Info.data.DataValue[Info.columnIndex]}}" class="nav-link clickable"
         (click)="OpenURLFromGridRow(Info.columnIndex, Info.rowIndex, Info.data.RowNumber, item.lBusinessProcessInstanceCurrentStateDataId)">{{Info.data.DataValue[Info.columnIndex]}}</a>
    </div>

    <div *dxTemplate="let StateRow of 'detail'">

      <div class="col-lg-6 col-md-6 col-sm-6">
        <div *ngFor="let DataContext of StateRow.data.BusinessProcessStateGridData; let i = index; let even = even;">
          <div *ngIf="DataContext.DisplayOrder % 2 === 0">

            <div class="dx-field" *ngIf="DataContext.DataType =='DropDown'" style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-select-box id="sb_ItemSource_{{i}}7"
                               class="cl-select_box" [dataSource]="DataContext.ItemSource" displayExpr="DisplayMember"
                               valueExpr="DisplayMember" [(value)]="DataContext.DataValue" [readOnly]="DataContext.IsReadOnly"
                               [searchEnabled]="true"
                               (onSelectionChanged)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)"
                               itemTemplate="item">
                  <div *dxTemplate="let data of 'item'">
                    <div id="WD_ItemSource_{{i}}_DB" style="display:inline-block">
                      {{data.DisplayMember}}
                    </div>
                  </div>
                  <dxo-drop-down-options container="#sb_ItemSource_{{i}}7" [hideOnParentScroll]="false"></dxo-drop-down-options>
                </dx-select-box>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Multi Select Combo Box'"
                 style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">

                <dx-tag-box class="dxTagBox" [items]="DataContext.ItemSource" [showSelectionControls]="true"
                            [searchEnabled]="true" valueExpr="DisplayMember" displayExpr="DisplayMember"
                            [(value)]="DataContext.MultiSelectedItems" placeholder="Select ..." applyValueMode="instantly"
                            [showClearButton]="true"
                            (onValueChanged)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)">
                </dx-tag-box>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Search Box'" style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-autocomplete class="cl-autocomplete" [placeholder]="DataContext.ColumnHeader"
                                 [dataSource]="DataContext.ItemSource" valueExpr="DisplayMember" [showClearButton]="true"
                                 [searchTimeout]="500" [(value)]="DataContext.DataValue"
                                 (onValueChanged)="GetDataForStateDataGridDetailACB(StateRow.data.RowNumber,DataContext.DataField,item.lwfBusinessProcessStateDataId, $event)"
                                 (onChange)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)"
                                 [maxItemCount]="30" [(opened)]="DataContext.Opened" [disabled]="DataContext.IsReadOnly"
                                 itemTemplate="item">
                  <div *dxTemplate="let data of 'item'">
                    <div id="WD_ItemSource_{{i}}_ACB">{{data.DisplayMember}}</div>
                  </div>
                </dx-autocomplete>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Multiline String' "
                 style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-text-area class="cl-text-area" [height]="DataContext.Height" [maxLength]="DataContext.TextSize"
                              [readOnly]="DataContext.IsReadOnly"
                              (onChange)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)"
                              [placeholder]="DataContext.ColumnHeader" [(value)]="DataContext.DataValue"></dx-text-area>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Date Picker' "
                 style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <app-date-picker id="dbDate{{i}}5" class="cl-date-box" type="date" [value]="DataContext.DataValue"
                                 [disabled]="DataContext.IsReadOnly"
                                 (onDatePickerValueChanged)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event, DataContext.DataValue)"
                                 placeholder="dd-MMM-yyyy" displayFormat="dd-MMM-yyyy">
                </app-date-picker>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Alpha Numeric' "
                 style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-text-box class="cl-text-box" [height]="DataContext.Height" [maxLength]="DataContext.TextSize"
                             [readOnly]="DataContext.IsReadOnly"
                             (onChange)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)"
                             [placeholder]="DataContext.ColumnHeader" [(value)]="DataContext.DataValue"></dx-text-box>
              </div>
            </div>


            <div class="dx-field" *ngIf="DataContext.DataType =='Numeric/Money' "
                 style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-number-box class="cl-number-box" [step]="0" [format]="DataContext.FormatString"
                               [min]="DataContext.Min" [max]="DataContext.Max"
                               (onKeyUp)="onKeyPressNumberBoxStateDataGridDetail($event,DataContext,StateRow.data.RowNumber,item.lwfBusinessProcessStateDataId)"
                               (onValueChanged)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)"
                               [(value)]="DataContext.DataValue" [readOnly]="DataContext.IsReadOnly"
                               style="text-align:right;"></dx-number-box>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Check Box' " style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-check-box class="cl-check-box" [(value)]="DataContext.DataValue" [disabled]="DataContext.IsReadOnly"
                              (onValueChanged)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)">
                </dx-check-box>
              </div>
            </div>


            <div class="dx-field" *ngIf="item.DataType =='Reference Data'" style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <a title="{{Info.data.DataValue[Info.columnIndex]}}" class="nav-link clickable"
                   (click)="OpenReferenceDataURLFromGridRow(DataContext.columnIndex, DataContext.rowIndex, DataContext.data.RowNumber, item.lBusinessProcessInstanceCurrentStateDataId)">{{DataContext.data.DataValue[DataContext.columnIndex]}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-6 col-md-6 col-sm-6">
        <div *ngFor="let DataContext of StateRow.data.BusinessProcessStateGridData; let i = index; let even = even;">
          <div *ngIf="DataContext.DisplayOrder % 2 > 0">

            <div class="dx-field" *ngIf="DataContext.DataType =='DropDown'" style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-select-box id="sb_ItemSource_{{i}}8"
                               class="cl-select_box" [dataSource]="DataContext.ItemSource" displayExpr="DisplayMember"
                               valueExpr="DisplayMember" [(value)]="DataContext.DataValue" [readOnly]="DataContext.IsReadOnly"
                               [searchEnabled]="true"
                               (onSelectionChanged)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)"
                               itemTemplate="item">
                  <div *dxTemplate="let data of 'item'">
                    <div id="WD_ItemSource_{{i}}_DB" style="display:inline-block">
                      {{data.DisplayMember}}
                    </div>
                  </div>
                  <dxo-drop-down-options container="#sb_ItemSource_{{i}}8" [hideOnParentScroll]="false"></dxo-drop-down-options>
                </dx-select-box>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Multi Select Combo Box'"
                 style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">

                <dx-tag-box class="dxTagBox" [items]="DataContext.ItemSource" [showSelectionControls]="true"
                            [searchEnabled]="true" valueExpr="DisplayMember" displayExpr="DisplayMember"
                            [(value)]="DataContext.MultiSelectedItems" placeholder="Select ..." applyValueMode="instantly"
                            [showClearButton]="false"
                            (onValueChanged)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)">
                </dx-tag-box>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Search Box'" style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-autocomplete class="cl-autocomplete" [placeholder]="DataContext.ColumnHeader"
                                 [dataSource]="DataContext.ItemSource" valueExpr="DisplayMember" [showClearButton]="true"
                                 [searchTimeout]="500" [(value)]="DataContext.DataValue"
                                 (onValueChanged)="GetDataForStateDataGridDetailACB(StateRow.data.RowNumber,DataContext.DataField,item.lwfBusinessProcessStateDataId, $event)"
                                 (onChange)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)"
                                 [maxItemCount]="30" [(opened)]="DataContext.Opened" [disabled]="DataContext.IsReadOnly"
                                 itemTemplate="item">
                  <div *dxTemplate="let data of 'item'">
                    <div id="WD_ItemSource_{{i}}_ACB">{{data.DisplayMember}}</div>
                  </div>
                </dx-autocomplete>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Multiline String' "
                 style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-text-area class="cl-text-area" [height]="DataContext.Height" [maxLength]="DataContext.TextSize"
                              [readOnly]="DataContext.IsReadOnly"
                              (onChange)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)"
                              [placeholder]="DataContext.ColumnHeader" [(value)]="DataContext.DataValue"></dx-text-area>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Date Picker' "
                 style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <app-date-picker id="dbDate{{i}}6" class="cl-date-box" type="date" [value]="DataContext.DataValue"
                                 [disabled]="DataContext.IsReadOnly"
                                 (onDatePickerValueChanged)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event, DataContext.DataValue)"
                                 placeholder="dd-MMM-yyyy" displayFormat="dd-MMM-yyyy">
                </app-date-picker>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Alpha Numeric' "
                 style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-text-box class="cl-text-box" [height]="DataContext.Height" [maxLength]="DataContext.TextSize"
                             [readOnly]="DataContext.IsReadOnly"
                             (onChange)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)"
                             [placeholder]="DataContext.ColumnHeader" [(value)]="DataContext.DataValue"></dx-text-box>
              </div>
            </div>


            <div class="dx-field" *ngIf="DataContext.DataType =='Numeric/Money' "
                 style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-number-box class="cl-number-box" [step]="0" [format]="DataContext.FormatString"
                               [min]="DataContext.Min" [max]="DataContext.Max"
                               (onKeyUp)="onKeyPressNumberBoxStateDataGridDetail($event,DataContext,StateRow.data.RowNumber,item.lwfBusinessProcessStateDataId)"
                               (onValueChanged)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)"
                               [(value)]="DataContext.DataValue" [readOnly]="DataContext.IsReadOnly"
                               style="text-align:right;"></dx-number-box>
              </div>
            </div>

            <div class="dx-field" *ngIf="DataContext.DataType =='Check Box' " style="padding-top:5px;padding-left:2px;">
              <div class="dx-field-label">{{DataContext.ColumnHeader}}</div>
              <div class="dx-field-value">
                <dx-check-box class="cl-check-box" [(value)]="DataContext.DataValue" [disabled]="DataContext.IsReadOnly"
                              (onValueChanged)="StateDataGridDetailColumnValueChanged(StateRow.data.RowNumber,DataContext.DataField,DataContext.ColumnHeader,item.lwfBusinessProcessStateDataId, $event)">
                </dx-check-box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </dx-data-grid>
</ng-template>

<ng-template #StateDataFieldSection let-item="item" let-instanceId="instanceId">
  <ng-container *ngIf="item.DataType =='Header' && (item.IsVisible == 1)">
    <div class="cl-section-header">
      {{item.DisplayName}}
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Dropdown' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
      </div>
      <div class="dx-field-value"
           [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
        <dx-select-box id="sb_statedatafield{{instanceId}}"
                       class="cl-select_box" [dataSource]="item.ItemSource" displayExpr="DisplayMember"
                       valueExpr="DisplayMember" [(value)]="item.DataValue"
                       (onSelectionChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"
                       [readOnly]="item.IsEnabled || item.IsStateDataReadOnly" [searchEnabled]="true"
                       [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}" itemTemplate="item">
          <div *dxTemplate="let data of 'item'">
            <div id="WD_ItemSource_{{i}}_DB" style="display:inline-block">{{data.DisplayMember}}</div>
          </div>
        </dx-select-box>
        <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px;float:left"
                [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}" class="btn btn-info btn-sm clickable"
                title="{{item.LinkName}}">
          <span style="top: -1px; "
                [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Button' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-value" style="text-align: right;">
        <a *ngIf="item.DataType == 'Button' && (item.IsVisible == 1 || item.IsStateDataVisible)"
           class="btn btn-info btn-sm clickable" title="Add new" (click)="addStateGridNewRow()">
          <span class="dx-icon dx-icon-add" style="top: -1px; "></span>
        </a>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Mail Attachment' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
      </div>
      <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
        <input type="file" [attr.id]="item.lBusinessProcessInstanceCurrentStateDataId" class="hidden"
               (change)="fileChange($event,item.lBusinessProcessInstanceCurrentStateDataId,item.DataCaption)" />
        <label [attr.for]="item.lBusinessProcessInstanceCurrentStateDataId" class="uploadlabel">Attach file</label>
        <div>
          <button class="downloadLink" title="{{item.DataValue}}">{{item.DataValue}}</button>&nbsp;&nbsp;
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='File Chooser' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}" [ngClass]="{'Disabled' : item.IsStateDataReadOnly }">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
      <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
        <input type="file" [attr.id]="item.lBusinessProcessInstanceCurrentStateDataId" class="hidden"
               (change)="fileUpload($event,item.lBusinessProcessInstanceCurrentStateDataId,item.DataCaption)"
               [ngClass]="{'Disabled' : item.IsStateDataReadOnly }" />
        <label [attr.for]="item.lBusinessProcessInstanceCurrentStateDataId" class="uploadlabel"
               [ngClass]="{'Disabled' : item.IsStateDataReadOnly }">Choose file</label>
        <div *ngFor="let FileDetail of item.FileDetail" class="file_chooser_iniline_flex_display">
          <button (click)="DownLoad(item.lBusinessProcessInstanceCurrentStateDataId,FileDetail.FilePath)" class="downloadLink"
                  title="{{FileDetail.FileName}}">
            {{FileDetail.FileName}}
          </button>&nbsp;&nbsp;
          <button type="button" class="btn btn-default btn-sm"
                  (click)="DeleteFile(item.lBusinessProcessInstanceCurrentStateDataId,FileDetail.FilePath)" style="border:none;"
                  [ngClass]="{'Disabled' : item.IsStateDataReadOnly }">
            <span class="glyphicon glyphicon-trash" style="padding-bottom:7px;"></span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Due Date Specifier' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
      <div class="dx-field-value">
        <table>
          <tr>
            <td style="width:30%">
              <dx-number-box class="cl-number-box" [step]="0" format="#,##0.##" [(value)]="item.DueDate"
                             [disabled]="item.IsEnabled || item.IsStateDataReadOnly" style="text-align:right;"
                             (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)">
              </dx-number-box>
            </td>
            <td style="padding-left:2px;">
              <dx-select-box id="sbDateSpecifier{{instanceId}}"
                             class="cl-select_box" [dataSource]="item.ItemSource" displayExpr="DisplayMember"
                             valueExpr="DisplayMember" [(value)]="item.DueDateRule"
                             (onSelectionChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"
                             [readOnly]="item.IsEnabled || item.IsStateDataReadOnly" [searchEnabled]="true" style="width:100%"
                             itemTemplate="item">
                <div *dxTemplate="let data of 'item'">
                  <div id="WD_ItemSource_{{i}}_DB" style="display:inline-block">
                    {{data.DisplayMember}}
                  </div>
                </div>
                <dxo-drop-down-options container="#sbDateSpecifier{{instanceId}}" [hideOnParentScroll]="false"></dxo-drop-down-options>
              </dx-select-box>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Reference Data' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
      </div>
      <div class="dx-field-value">
        <div class="row">
          <div class="col-md-8 col-lg-6 col-sm-6 inputBeforebtnCopy">
            <dx-text-box class="cl-text-box" [height]="30" [readOnly]="item.IsEnabled || item.IsStateDataReadOnly"
                         [visible]="item.ReferenceDataTextBoxVisible" [placeholder]="item.PlaceHolder" [(value)]="item.DataValue"
                         (onFocusOut)="ReferenceTextBoxLostFocus(item.lBusinessProcessInstanceCurrentStateDataId)"
                         (onChange)="ReferenceTextBoxLostFocus(item.lBusinessProcessInstanceCurrentStateDataId)"></dx-text-box>
            <button (click)="OpenReferenceDataURL(item.lBusinessProcessInstanceCurrentStateDataId)"
                    [ngStyle]="{'display':item.ReferenceDataURLVisible ? 'block':'none'}"
                    class="downloadLink textRefrence" title="{{item.DataValue}}">
              {{item.DataValue}}
            </button>
          </div>&nbsp;
          <div class="col-md-4  col-lg-6 col-sm-6  btnCopyEdit">
            <dx-button text="Copy" hint="Copy"
                       (onClick)="copyMessage(item.DataValue,item.lBusinessProcessInstanceCurrentStateDataId)"
                       class="btn-secondary"
                       [visible]="item.IsStateDataReadOnly == 0 && item.IsCopyButtonEnabled == 1"></dx-button>&nbsp;

            <dx-button text="Edit" hint="Edit"
                       (onClick)="EditReferenceData(item.lBusinessProcessInstanceCurrentStateDataId)" class="btn-secondary"
                       [visible]="item.IsStateDataReadOnly == 0"></dx-button>
          </div>
        </div>

      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Multi Select Combo Box' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
      </div>
      <div class="dx-field-value">
        <dx-tag-box id="sb_statedatafield{{instanceId}}"
                    class="dxTagBox" [items]="item.ItemSource" [showSelectionControls]="true" [searchEnabled]="true"
                    valueExpr="DisplayMember" displayExpr="DisplayMember" [(value)]="item.MultiSelectedItems"
                    placeholder="Select ..." applyValueMode="instantly" [showClearButton]="false"
                    [disabled]="item.IsEnabled || item.IsStateDataReadOnly"
                    (onValueChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)">
        </dx-tag-box>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Search Box' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
      </div>
      <div class="dx-field-value"
           [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
        <dx-autocomplete class="cl-autocomplete" [placeholder]="item.PlaceHolder" [dataSource]="item.ItemSource"
                         valueExpr="DisplayMember" [showClearButton]="true" [searchTimeout]="500" [(value)]="item.DataValue"
                         (onValueChanged)="GetDataForACB(item.lwfBusinessProcessInstanceId,item.lwfBusinessProcessStateDataId,item)"
                         (onSelectionChanged)="TextAreaOnChangeACB(item.lwfBusinessProcessInstanceId,item.DataCaption,item,$event)"
                         [maxItemCount]="30" [disabled]="item.IsEnabled || item.IsStateDataReadOnly"
                         [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}" itemTemplate="item">
          <div *dxTemplate="let data of 'item'">
            <div id="WD_ItemSource_{{i}}_ACB">{{data.DisplayMember}}</div>
          </div>
        </dx-autocomplete>
        <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px;float:left"
                [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}" class="btn btn-info btn-sm clickable"
                title="{{item.LinkName}}">
          <span style="top: -1px; "
                [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Alpha Numeric' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
      </div>
      <div class="dx-field-value"
           [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
        <dx-text-area class="cl-text-area" [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}" [height]="35"
                      [maxLength]="item.TextSize" [readOnly]="item.IsEnabled || item.IsStateDataReadOnly"
                      [placeholder]="item.PlaceHolder" [(value)]="item.DataValue"
                      (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"></dx-text-area>
        <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px;float:left"
                [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}" class="btn btn-info btn-sm clickable"
                title="{{item.LinkName}}">
          <span style="top: -1px; "
                [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Multiline String' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
      </div>
      <div class="dx-field-value">
        <dx-text-area class="cl-text-area" [height]="item.Height" [maxLength]="item.TextSize"
                      [readOnly]="item.IsEnabled || item.IsStateDataReadOnly" [placeholder]="item.PlaceHolder"
                      [(value)]="item.DataValue"
                      (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)"></dx-text-area>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Date Picker' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
      </div>
      <div class="dx-field-value">
        <app-date-picker id="sb_statedatafield{{instanceId}}" class="cl-date-box" type="date" [value]="item.DataValue"
                         [disabled]="item.IsEnabled || item.IsStateDataReadOnly" placeholder="dd-MMM-yyyy" displayFormat="dd-MMM-yyyy"
                         (onDatePickerValueChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption, $event, item)">
        </app-date-picker>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Label' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font>
      </div>
      <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
        {{item.DataValue}}
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Numeric/Money' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
      <div class="dx-field-value"
           [ngStyle]="{'display':item.IsLinkEnabled ? 'flex':'block','margin-bottom':item.IsLinkEnabled ? '23px':'0px'}">
        <dx-number-box class="cl-number-box" [step]="0" [ngStyle]="{'width':item.IsLinkEnabled ? '92%':'100%'}"
                       [format]="item.FormatString"
                       [ngClass]="{'negativeFontColor' : item.DataValue != null && item.DataValue != undefined && item.DataValue < 0 }"
                       [min]="item.Min" [max]="item.Max" [(value)]="item.DataValue" (onKeyUp)="onKeyPressNumberBoxState($event,item)"
                       (onChange)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DisplayName)"
                       [disabled]="item.IsEnabled || item.IsStateDataReadOnly" style="text-align:right;"></dx-number-box>
        <button (click)="OpenLinkURL(item.LinkURL)" style="margin-left:2px;float:left"
                [ngStyle]="{'display':item.IsLinkEnabled ? 'block':'none'}" class="btn btn-info btn-sm clickable"
                title="{{item.LinkName}}">
          <span style="top: -1px; "
                [ngClass]="CheckLink(item.LinkName) ? 'dx-icon dx-icon-add' : 'glyphicon glyphicon-arrow-right'"></span>
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Check Box' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label" title="{{item.DisplayName}}">{{item.DisplayName}}<font color="red"
                                  *ngIf="item.IsMandatory == 1">*</font>
      </div>
      <div class="dx-field-value">
        <dx-check-box class="cl-check-box" [(value)]="item.DataValue"
                      [disabled]="item.IsEnabled || item.IsStateDataReadOnly"
                      (onValueChanged)="TextAreaOnChange(item.lwfBusinessProcessInstanceId,item.DataCaption)">
        </dx-check-box>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Dependent Data Label' && (item.IsVisible == 1)">
    <div class="dx-field" *ngIf="item.DataType =='Dependent Data Label' && (item.IsVisible == 1)">
      <div class="dx-field-label" title="{{item.DisplayName}}" *ngIf="item.IsDataCaptionVisible == 1">{{item.DisplayName}}</div>
      <div class="dx-field-value" style="padding: 8px 15px 9px 0; ">
        {{item.DataValue}}
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Counterparty Tree View' && (item.IsVisible == 1)">
    <div class="dx-field">
      <div class="dx-field-label">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
      <div style="width:85%;float:left">
        <dx-tree-view #stateworkflowTreeView id="trvTradingCounterpartyHierarchy" [dataSource]="item.DataValue"
                      keyExpr="ID"
                      displayExpr="ChildTradingCounterparty"
                      itemsExpr="TradingCounterpartyLegalHierarchyOwnershippings"
                      expandedExpr="isExpanded"
                      selectedExpr="isSelected"
                      selectionMode="single"
                      focusStateEnabled="false"
                      selectByClick="true"
                      itemTemplate="cptyTemplate"
                      style="border: 1px solid #4F87F6;border-radius: 5px;"
                      width="100%"
                      height="22rem">
          <div *dxTemplate="let cpty of 'cptyTemplate'">
            <span title="{{cpty.ChildTradingCounterparty}}">{{cpty.ChildTradingCounterparty}}</span>
          </div>
        </dx-tree-view>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Data Grid' && (item.IsVisible == 1) && item.PositionGridWithFields == 1">
    <div class="dx-field">
      <div class="dx-field-label">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
      <div class="dx-field-value" style="text-align: right;">
        <dx-button text="Add Row" hint="Add Row"
                   (onClick)="AddRowForStateGenericDataGrid($event,item.lBusinessProcessInstanceCurrentStateDataId)"
                   [visible]="item.IsAddRowEnabled" style="width:120px;height:25px;"></dx-button>
      </div>
      <div style="width:85%;float:left;height:25rem" class="padding0px">
        <ng-container *ngTemplateOutlet="DataGrid; context: {item: item}">
        </ng-container>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="item.DataType =='Content Frame' && (item.IsVisible == 1) && item.IsHalfWidth == 1">
    <div class="dx-field">
      <div class="dx-field-label">{{item.DisplayName}}<font color="red" *ngIf="item.IsMandatory == 1">*</font></div>
    </div>
    <iframe [src]="item.SafeUrl" class="ContentFrame"></iframe>
  </ng-container>
</ng-template>

<!-- document template generate popup-->
<div class="modal fade" role="dialog" [ngClass]="{'fadeIn': __bIsDataGridDocumentGeneratePopup == true }" id="documentGenerateModal">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <span class="modal-title">Document Template</span>
        <button type="button" class="close" (click)="onPopupCloseButtonClick($event)" data-dismiss="modal">&times;</button>
      </div>
      <div class="st_popscrl">
        <div class="modal-body message-border">
          <div class="row" *ngIf="!hideTemplateDropDown">
            <div class="dx-field col-lg-6 col-md-6">
              <div class="dx-field-label width150">Template category:</div>
              <div class="dx-field">
                <div class="dx-field-value">
                  <div class="col-md-12 col-xs-12 col-xs-12 padding0px">
                    <dx-tag-box [dataSource]="__oDocumentCategories" valueExpr="lDocumentCategoryId" displayExpr="DocumentCategoryName"
                                [multiline]="true" [showClearButton]="true" class="tag-box" placeholder=""
                                applyValueMode="instantly" [showSelectionControls]="true" (onValueChanged)="DocumentCategoryDropDownBoxValue($event)"
                                [(value)]="__selectedCategory" selectAllMode="allPages">
                    </dx-tag-box>

                  </div>
                </div>
              </div>

            </div>
            <div class="dx-field col-lg-6 col-md-6">
              <div class="dx-field-label width94">Templates :</div>
              <div class="dx-field">
                <div class="dx-field-value">
                  <div class="col-md-12 col-xs-12 col-xs-12 padding0px">
                    <dx-tag-box [dataSource]="__oTemplatesByCategory" #documentTemplates id="documentTemplates" valueExpr="lDocumentTemplateId" displayExpr="Name" [searchEnabled]="true"
                                [multiline]="true" [showClearButton]="true" class="tag-box" placeholder=""
                                applyValueMode="instantly" [showSelectionControls]="true" (onValueChanged)="LoadDocumentTemplate($event)"
                                [(value)]="templates" selectAllMode="allPages">
                    </dx-tag-box>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="dx-field">
              <div class="dx-field-value Rich_Text_Box_Anchor" style="width: 100%;">
                <div *ngIf="__IsFroalaConfigReady" [froalaEditor]="__oFroalaEditorOptionReadOnly" [(froalaModel)]="templateContent"></div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <table class="table">
          <tr>
            <td class="table-cell-audit-text"><div></div></td>
            <td class="table-cell-audit-button">
              <dx-button id="btnMailTemplateCancel" (onClick)="onPopupCloseButtonClick($event)" text="Cancel" class="footer-button"></dx-button>
            </td>
            <td>
              <dx-button id="btnDownload" (onClick)="onPopupSaveAndDownloadButtonClick($event)" class="footer-button" text="Download to your computer"></dx-button>
            </td>
            <td>
              <dx-button id="btnSaveFiletoSharepoint" (onClick)="btnSaveFiletoSharepoint_Click($event)" class="footer-button" text="Save to SharePoint"></dx-button>
            </td>
          </tr>
        </table>
      </div>

    </div>

  </div>
</div>
<div class="modal fade" role="dialog" [ngClass]="{'fadeIn': __bSharepointDocumentGeneratePopup == true }" id="documentUploadSharepoint">
  <div class="modal-dialog modal-lg-filemanager-sharepoint modal-dialog-centered">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header">
        <span class="modal-title">Save to SharePoint</span>
        <button type="button" class="close" (click)="btnUploadSharepointClose_Click($event)" data-dismiss="modal">&times;</button>
      </div>
      <div class="st_popscrl">
        <div class="modal-body message-border">
          <div class="row">
            <div class="dx-field" style="padding-top:5px;padding-left:2px;">
              <div style="width:100%;float:left" class="padding0px">
                <FileManager #filemanager_UploadSharePoint id="filemanager_UploadSharePoint" [FileSystem]="__sFileSystem" [Directory]="__sDirectory" [__bMenuVisible]="false" *ngIf="__bUploadSharepointFileManagerReady"></FileManager>
              </div>
            </div>
          </div>

        </div>
      </div>
      <!-- Modal footer -->
      <div class="modal-footer">
        <table class="table">
          <tr>
            <td class="table-cell-audit-text"><div></div></td>
            <td class="table-cell-audit-button">
              <dx-button id="btnUploadSharepointClose" (onClick)="btnUploadSharepointClose_Click($event)" text="Cancel" class="footer-button"></dx-button>
            </td>
            <td>
              <dx-button id="btnUploadSharepoint" (onClick)="btnUploadSharepoint_Click($event)" class="footer-button" text="Save generated file"></dx-button>
            </td>
          </tr>
        </table>

      </div>

    </div>

  </div>
</div>


<dx-load-panel id="pnlLoad"
               shadingColor="rgba(0,0,0,0.4)"
               [position]="{ at: 'center' }"
               [(visible)]="__bIsLoadingVisible"
               [showIndicator]="true"
               [showPane]="true"
               [shading]="true"
               [hideOnOutsideClick]="false"
               [height]="75"
               [width]="150"
               message="Please Wait...">
</dx-load-panel>

<dx-load-panel id="apilLoad"
               shadingColor="rgba(0,0,0,0.4)"
               [position]="{ at: 'center' }"
               [(visible)]="__bIsLoadingVisibleForPermission"
               [showIndicator]="true"
               [showPane]="true"
               [shading]="true"
               [hideOnOutsideClick]="false"
               [height]="75"
               [width]="150"
               message="Loading...">
</dx-load-panel>

<app-confirmation [__iPopupHeight]="'auto'"></app-confirmation>
